import { useToast } from 'vue-toastification'

const settings = {
    position: 'bottom-right',
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: 'button',
    icon: true,
    rtl: false,
}

const toast = useToast()

function getText(message) {
    return message instanceof Error ? message.message : message
}

function isUnauthorizedMessage(message, text) {
    if (message instanceof Error && message.response?.status === 401) {
        return true
    }

    return text === 'Unauthenticated.'
}

/**
 * Display an error toast notification.
 *
 * @param {string|Error} message - Error message or Error object to display
 * @returns {void}
 *
 * @example
 * errorMessage('Failed to save changes')
 * errorMessage(new Error('Something went wrong'))
 */
export function errorMessage(message) {
    const text = getText(message)

    if (isUnauthorizedMessage(message, text)) {
        return
    }

    toast.error(text, settings)
}

/**
 * Display a success toast notification.
 *
 * @param {string|Error} message - Success message or Error object to display
 * @returns {void}
 *
 * @example
 * successMessage('Changes saved successfully')
 */
export function successMessage(message) {
    const text = getText(message)
    toast.success(text, settings)
}

/**
 * Display an info toast notification.
 *
 * @param {string|Error} message - Info message or Error object to display
 * @returns {void}
 *
 * @example
 * infoMessage('Your session will expire in 5 minutes')
 */
export function infoMessage(message) {
    const text = getText(message)
    toast.info(text, settings)
}
